import React, { Component } from 'react';
import { render } from '@testing-library/react';
import { Container, Table, Row, Col } from 'react-bootstrap';

class Skills extends Component { 

    state = { displayImprint: false };

    toggleImprint = () => {
        this.setState({ displayImprint: !this.state.displayImprint })
    }

    render() {
        return (
            <Container>
                <Row>
                    <Col><h3>Skills</h3></Col>
                </Row>
                <Row>
                    <Col>
                        <Table>
                            <tr><td>SQL (Oracle, MSSQL, MySQL, SQLite)</td><td>20 Jahre</td></tr>
                            <tr><td>Javascript / HTML, CSS</td><td>18 Jahre</td></tr>
                            <tr><td>C# / .Net</td><td>15 Jahre</td></tr>
                            <tr><td>VBA</td><td>10 Jahre</td></tr>
                            <tr><td>ASP / WPF / WWF</td><td>8 Jahre</td></tr>
                            <tr><td>PHP / Zend / MVC</td><td>1 Jahr</td></tr>
                            <tr><td>Java / Spring</td><td>1 Jahr</td></tr>
                            <tr><td>Jenkins, CI/CD</td><td>1 Jahr</td></tr>
                            <tr><td rowspan="4">Tools</td><td colspan="2">Git, SVN, TFS</td></tr>
                            <tr><td colspan="2">Jenkins, Kubernetes</td></tr>
                            <tr><td colspan="2">Docker</td></tr>
                            <tr><td colspan="2">Ranorex</td></tr>
                            <tr><td rowspan="4">Sprachen</td><td colspan="2">Deutsch (Muttersprache)</td></tr>
                            <tr><td colspan="2">Englisch (Wort und Schrift)</td></tr>
                        </Table>
                        <br />&nbsp;
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default Skills;
